// Expert courses API service
const BASE_URL = "http://staging.maamaas.com:8080/protohub/api/expert/courses";

// ===== GET /protohub/api/expert/courses/expert/{expertId} =====
export async function getCourses(expertId) {
    const res = await fetch(`${BASE_URL}/expert/${encodeURIComponent(expertId)}`, {
        method: "GET",
        headers: { Accept: "application/json" },
    });

    if (!res.ok) {
        const text = await res.text().catch(() => "");
        throw new Error(text || `Failed to load courses (status ${res.status})`);
    }

    return res.json();
}

// ===== POST /protohub/api/expert/courses  (application/json) =====
export async function createCourse(payload) {
    const res = await fetch(BASE_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(payload),
    });

    if (!res.ok) {
        const text = await res.text().catch(() => "");
        throw new Error(text || `Failed to add course (status ${res.status})`);
    }

    return res.json().catch(() => ({}));
}

// ===== PUT /protohub/api/expert/courses/{courseId}  (application/json) =====
export async function updateCourse(courseId, payload) {
    const res = await fetch(`${BASE_URL}/${encodeURIComponent(courseId)}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(payload),
    });

    if (!res.ok) {
        const text = await res.text().catch(() => "");
        throw new Error(text || `Failed to update course (status ${res.status})`);
    }

    return res.json().catch(() => ({}));
}

// ===== DELETE /protohub/api/expert/courses/{courseId} =====
export async function deleteCourse(courseId) {
    const res = await fetch(`${BASE_URL}/${encodeURIComponent(courseId)}`, {
        method: "DELETE",
        headers: { Accept: "application/json" },
    });

    // Log the raw status so it shows up in the console no matter what happens next.
    console.log(`DELETE ${BASE_URL}/${courseId} -> status ${res.status}`);

    if (!res.ok) {
        const text = await res.text().catch(() => "");
        throw new Error(text || `Failed to delete course (status ${res.status})`);
    }

    // 204 No Content is the normal, correct response for a DELETE — nothing to parse.
    if (res.status === 204) {
        return { success: true };
    }

    // Some backends return 200 with a body like { success: false, message: "..." }.
    // Read as text first so we don't blow up on an empty body, then try to parse it,
    // and — critically — check for an explicit failure flag if the body has one.
    const text = await res.text().catch(() => "");
    if (!text) {
        return { success: true };
    }

    try {
        const data = JSON.parse(text);
        if (data && data.success === false) {
            throw new Error(data.message || "Server reported the delete did not succeed.");
        }
        return data;
    } catch (parseErr) {
        // Body wasn't JSON (e.g. plain "OK" text) — treat as success since res.ok was true.
        return { success: true, raw: text };
    }
}


// ===== GET /protohub/api/expert/courses/expert/{expertId} =====
export async function getCoursess(expertId) {
    const res = await fetch(`${BASE_URL}/expert/${encodeURIComponent(expertId)}`, {
        method: "GET",
        headers: { Accept: "application/json" },
    });

    if (!res.ok) {
        const text = await res.text().catch(() => "");
        throw new Error(text || `Failed to load courses (status ${res.status})`);
    }

    return res.json();
}

// ===== GET /protohub/api/expert/bookings/{expertId} =====
export async function getExpertBookings(expertId) {
    const res = await fetch(
        `http://staging.maamaas.com:8080/protohub/api/expert/bookings/${encodeURIComponent(expertId)}`,
        {
            method: "GET",
            headers: { Accept: "application/json" },
        }
    );

    if (!res.ok) {
        const text = await res.text().catch(() => "");
        throw new Error(text || `Failed to load bookings (status ${res.status})`);
    }

    return res.json();
}